




























































import Vue from 'vue'
import Modal from '@/pmd/components/common/Modal.vue'
import config from '@/config'
import axios from 'axios'
import { trackGaEvent } from '@/util/helper'

import { Location } from '@/models'

export default Vue.extend({
  props: ['modalShow', 'currentLocationId', 'siteUrl'],
  components: {
    Modal,
  },
  data() {
    return {
      popupWidth: 600,
      cms: 'Other',
      sending: false,
      location: {} as Location,
      website: this.siteUrl,
      cmsList: [
        'wordpress',
        'squarespace',
        'joomla',
        'duda',
        'shopify',
        'weebly',
      ],
    }
  },
  computed: {
    disableButton(): boolean {
      return this.website === '' || this.sending
    },
  },
  async mounted() {
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
  },
  watch: {
    siteUrl: function (url) {
      this.website = url
    },
  },
  methods: {
    async checkCms() {
      let result = await this.$validator.validateAll('form-subaccount')
      if (!result) {
        return false
      }
      this.sending = true
      try {
        await this.location.ref.update({
          'launchpad.website': this.website,
          website: this.website,
        })
        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
        const response = await axios.get(
          `${config.cloudFunctionsUrl}/websiteCmsList?website=${this.website}`
        )
        if (response.status == 200) {
          const tech = response.data.technologies
          const detectedCms = tech.filter(t =>
            this.cmsList.includes(t.toLowerCase())
          )
          if (detectedCms.length) this.cms = detectedCms[0]
        }
        this.$root.$emit('detected-cms', this.cms)
        this.$root.$emit('get-screenshot')
        this.closeModal()
      } catch (err) {
        this.$root.$emit('detected-cms', this.cms)
        this.$root.$emit('get-screenshot')
        console.log(err)
      }
      this.sending = false
      trackGaEvent(
        'Launchpad',
        'WebChat Widget CMS',
        `Detected CMS for Webchat cms: ${this.cms} for location: ${this.currentLocationId}`
      )
    },
    closeModal() {
      console.log('Event got')
      this.$root.$emit('close-modal')
    },
  },
})
